<template>
  <div class="displayTicketDetailList">
    <!-- <div class="typesChoice">场次选择<van-button @click="showCalendar=true" icon="clock-o" size="mini" type="info">自选时间</van-button></div> -->
    <van-tabs v-model="active" animated sticky swipeable :ellipsis="false" @change="getTicketTypesList" class="dateTabs" title-active-color="#EE0A24">
      <van-tab v-for="item in date" :title="item" :key="item" :name="item">
        <ticket-detail-list-item :date="active" :list="list" :price="price" :useStyle="useStyle" :ticket="ticket" @buy="toBuyTickets" />
      </van-tab>
    </van-tabs>
    
    <van-calendar
     v-model="showCalendar" 
     position="right" 
     :round="false"
     :show-confirm="false" 
     type="single"
     @confirm="dateSelect"
     title="请选择购票时间" />

    <van-popup
      v-model="showTicketsItem" 
      closeable
      round
      position="bottom" 
      class="popupTickets"
    >
      <van-nav-bar title="场次信息" />
      <van-empty v-if="!popupList.length" description="当前场次无可售门票" />
      
      <ticket-detail-list-item v-else :list="popupList" :price="price" :useStyle="useStyle"  @buy="toBuyTickets" />
    </van-popup>
  </div>
</template>

<script>
// import { log } from 'util';
// import { watch } from 'fs';
import { getTicketsType } from '../api/api-ticket';

import TicketDetailListItem from './TicketDetailListItem'

export default {
  props:{
    date:{
      type:Array,
      dafault: []
    },
    price:{
      type: String,
      default: '0.00'
    },
    ticket:{
      type: String,
      default: ''
    },
    ticketId:{
      type: Number,
      default: 0
    },
    useStyle:{
      type:Number,
      default: 0
    }
  },
  data(){
    return{
      active:'',
      list: [],
      popupList: [],
      showCalendar: false,
      showTicketsItem: false
    }
  },
  methods:{
    async getTicketTypesList(date) {
      this.list = await getTicketsType({ id: this.ticketId, date })
    },
    async dateSelect(val){
      // eslint-disable-next-line no-unused-expressions
      this.popupList = await getTicketsType({ id: this.ticketId, date: `${val.getFullYear()}/${val.getMonth()+1}/${val.getDate()}`})
      if (this.popupList.length) {
        this.showTicketsItem = true
      }
    },
    toBuyTickets(type){
      this.$router.push({
        name: 'ticket_detail',
        query: {
          date: this.active,
          id: this.ticketId,
          type
        }
      })
    }
  },
  async created(){
    this.ticketId = this.$route.params.id
  },
  watch:{
    date(newVal){
      this.getTicketTypesList(newVal[0])
    }
  },
  components:{
    TicketDetailListItem
  }
}
</script>

<style lang="less" scoped>
  .typesChoice{
    width: calc(100% - 45px);
    padding: 5px 10px;
    margin: 10px;
    border-left: 5px solid #00A3AF;
    button{
      float: right;
      transform: translate(0,-5px);
    }
  }
  .dateTabs{
    background-color: #fff;
    padding-bottom: 2vh;
    border-top: 2px dotted rgba(0, 0, 0, .1);
  }
  .popupTickets{
    padding-top: 10%;
    height: 60%;
  }

</style>